import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Generic from '../Generic';

//Components
import InputField from '../InputType/InputField';
import SelectField from './SelectField';

const Content = styled.div`
  display: flex;
  flex: 1 0 auto;
  padding: 10px;
`

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  font-size: 18px;
  font-weight: 500;
`

const SelectFieldStyled = styled(SelectField)`

`
const InputFieldStyled = styled(InputField)`
  margin-right: 10px;
`

const SelectType = ({
  text,
  children,
  defaultValue,
  value,
  items,
  onChange,
  includeSetName,
  setName,
  onNameChange,
  ...other
}) => {
  return (
    <Generic {...other}>
      <Content>
        {children}
        <TextContainer>
          {text}
        </TextContainer>
      </Content>
      { includeSetName && (
        <InputFieldStyled
          placeholder='Set Name'
          type='set_name'
          value={setName}
          onChange={onNameChange}
        />
      )}
      <SelectFieldStyled
        value={value}
        items={items}
        onChange={onChange}
      />
    </Generic>
  )
}

SelectType.propTypes = {
  onClick: PropTypes.func,
};

SelectType.defaultProps = {
  type: null,
};

export default SelectType;
